module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapterbody"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "epi",
    attrs: {
      "id": "epi"
    }
  }, [_c('i', [_vm._v("And if the worldly forget you,")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("say to the silent earth: I flow.")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("To the swift water say: I am.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n   —Rainer Maria Rilke"), _c('br'), _vm._v(" "), _c('i', [_vm._v("The Sonnets to Orpheus")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc74ca2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epi.vue
// module id = 66
// module chunks = 0